export enum ScreenEnum {
  CalculationCepik3Screen = 'calculation.cepik3.screen',
  CalculationScreenInsurance = 'calculation.screen.insurance',
  Cepik30CheckoutScreen1 = 'cepik30Checkout.screen.1',
  Cepik30CheckoutScreen2 = 'cepik30Checkout.screen.2',
  CheckoutScreen1 = 'checkout.screen.1',
  CheckoutScreen2 = 'checkout.screen.2',
  CompareCepikDataScreen1 = 'compareCepikData.screen.1',
  CompareCepikDataScreen2 = 'compareCepikData.screen.2',
  DisableNotificationsScreen1 = 'disableNotifications.screen.1',
  FirstStepScreen = 'calculation.screen.first',
  LeadScreen1 = 'lead.screen.1',
  MubiLeasingScreen1 = 'mubiLeasing.screen.1',
  MubiLeasingScreen2 = 'mubiLeasing.screen.2',
  MubiLeasingScreen3 = 'mubiLeasing.screen.3',
  MubiLeasingShortPath = 'mubiLeasing.screen.shortPath',
  OperatorLeadScreen1 = 'operatorLead.screen.1',
  RecommendationScreen1 = 'recommendation.screen.1',
  RenewalRopForm = 'renewal.rop.form',
  Screen1 = 'screen.1',
  Screen2 = 'screen.2',
  Screen3 = 'screen.3',
  ScreenEmailAddress = 'screen.emailAddress',
  ScreenInsurance = 'calculation.screen.insurance',
  ShortCalculationPath = 'calculation.screen.shortPath',
  TerminationGeneratorScreen1 = 'terminationGenerator.screen.1',
  TerminationGeneratorScreen2 = 'terminationGenerator.screen.2',
}
